export default {
  route: {
    dashboard: 'Dashboard',
    introduction: 'Introduction',
    documentation: 'Documentation',
    guide: 'Guide',
    permission: 'Permission',
    pagePermission: 'Page Permission',
    directivePermission: 'Directive Permission',
    icons: 'Icons',
    components: 'Components',
    componentIndex: 'Introduction',
    tinymce: 'Tinymce',
    markdown: 'Markdown',
    jsonEditor: 'JSON Editor',
    dndList: 'Dnd List',
    splitPane: 'SplitPane',
    avatarUpload: 'Avatar Upload',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'CountTo',
    componentMixin: 'Mixin',
    backToTop: 'BackToTop',
    dragDialog: 'Drag Dialog',
    dragKanban: 'Drag Kanban',
    charts: 'Charts',
    keyboardChart: 'Keyboard Chart',
    lineChart: 'Line Chart',
    mixChart: 'Mix Chart',
    example: 'Example',
    nested: 'Nested Routes',
    bar: 'Bar',
    barProfile: 'Profile',
    barPosts: 'Posts',
    Table: 'Table',
    dynamicTable: 'Dynamic Table',
    dragTable: 'Drag Table',
    inlineEditTable: 'Inline Edit',
    complexTable: 'Complex Table',
    treeTable: 'Tree Table',
    customTreeTable: 'Custom TreeTable',
    tab: 'Tab',
    form: 'Form',
    createArticle: 'Create Article',
    editArticle: 'Edit Article',
    articleList: 'Article List',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    exportZip: 'Export Zip',
    theme: 'Theme',
    clipboardDemo: 'Clipboard',
    i18n: 'I18n',
    majorManage: 'major manage',
    courseManage: 'course manage',
    orderManage: 'order manage',
    userManage: 'user manage',
    courseSelect: 'course select',
    majorDetails: 'major detail',
    my: 'me',
    myOrder: 'my order',
    myCourse: 'my course',
    myCourseCourseware: 'courseware',
    myCourseDetailAbout: 'course about',
    myCourseDiscussionDetail: 'discussion detail',
    majorList: 'major list',
    majorCourseList: 'major courseList',
    majorAddCourse: 'major add course',
    majorEdit: 'edit major',
    schoolManage: 'school manage',
    schoolList: 'school list',
    schoolEdit: 'edit school',
    courseList: 'course list',
    courseInfo: 'course info',
    courseDiscussion: 'course discussion',
    orderList: 'order list',
    orderDetail: 'order detail',
    shopCart: 'shopCart',
    shopCartList: 'shopCart list',
    userList: 'user list',
    myOrderList: 'my order list',
    myCourseList: 'my course list',
    myCourseDetail: 'my course detail',
    myInfo: 'my info',
    resetPassword: 'reset rassword',
    myOrderDetail: 'my order detail',
    fileManage: 'file manage',
    fileUpload: 'file upload',
    fileList: 'file list',
    examManage: 'exam manage',
    examList: 'exam list',
    examDetail: 'exam detail',
    examEdit: 'edit exam',
    examAdd: 'add exam',
    examScoringList: 'exam paper list',
    examScoringDetail: 'exam paper detail',
    paperManage: 'paper manage',
    paperList: 'paper list',
    paperDetail: 'paper detail',
    paperAdd: 'add paper',
    paperEdit: 'edit paper',
    questionManage: 'question manage',
    questionList: 'question list',
    questionDetail: 'question detail',
    questionEdit: 'edit question',
    questionAdd: 'add question',
    scoreSearch: 'score search',
    scoreList: 'score list',
    courseOutline: 'course outline',
    courseUnitContent: 'course unit content',
    courseManageInfo: 'course info',
    courseTab: 'course tab',
    courseTextbook: 'course textbook',
    courseSetting: 'course setting',
    courseGrading: 'course grading',
    discussionDetail: 'discussion detail',
    courseDetail: 'course detail',
    courseStudyProgress: 'study progress manage',
    courseCourseware: 'course courseware',
    myOrderPayRedirect: 'pay redirect',
    enroll: 'enroll',
    enrollForm: 'enroll form',
    regularScoreQuery: 'regular score',
    examScoreQuery: 'exam score',
    myRegularScore: 'my regular score',
    userRegularScoreList: 'userRegularScoreList',
    myRegularScoreList: 'myRegularScoreOverview',
    myExamScore: 'myExamScore',
    myExamScoreList: 'myExamScoreList',
    myExamScoreDetail: 'myExamScoreDetail',
    entrustmentScoreQuery: 'entrustmentScoreQuery',
    myExamEnroll: 'myExamEnroll',
    myExamEnrollList: 'myExamEnrollList',
    myExamEnrollAdd: 'myExamEnrollAdd',
    examAudit: 'examAudit',
    auditPaperList: 'auditPaperList',
    courseAdd: 'courseAdd',
    courseExamList: 'courseExamList',
    courseExamDetail: 'courseExamDetail',
    courseExamEdit: 'courseExamEdit',
    courseExamAdd: 'courseExamAdd',
    examEnrollList: 'examEnrollList',
    examEnrollDetail: 'examEnrollDetail',
    myRegularScoreEnroll: 'myRegularScoreEnroll',
    enrollOrderList: 'enrollOrderList',
    renewalOrderList: 'renewalOrderList',
    examOrderList: 'examOrderList',
    organManage: 'organManage',
    organList: 'organList',
    organAdd: 'organAdd',
    organEdit: 'organEdit',
    messageManage: 'messageManage',
    messageList: 'messageList',
    messageEdit: 'messageEdit',
    messageDetail: 'messageDetail',
    messageAdd: 'messageAdd',
    myMessage: 'myMessage',
    goodsManage: 'goodsManage',
    goodsList: 'goodsList',
    goodsStudyList: 'goodsStudyList',
    goodsExamList: 'goodsExamList',
    goodsDetail: 'goodsDetail',
    goodsEdit: 'goodsEdit',
    goodsAdd: 'goodsAdd',
    roleManage: 'roleManage',
    roleList: 'roleList',
    roleAdd: 'roleAdd',
    roleEdit: 'roleEdit',
    roleTeacherList: 'roleTeacherList',
    teacherManage: 'teacherManage',
    teacherList: 'teacherList',
    teacherEdit: 'teacherEdit',
    teacherAdd: 'teacherAdd',
    regularScoreStaticQuery: 'regularScoreStaticQuery',
    homeworkManage: 'homeworkManage',
    homeworkQuestionList: 'homeworkQuestionList',
    homeworkQuestionEdit: 'homeworkQuestionEdit',
    homeworkQuestionAdd: 'homeworkQuestionAdd',
    homeworkPaperList: 'homeworkPaperList',
    homeworkPaperDetail: 'homeworkPaperDetail',
    homeworkPaperEdit: 'homeworkPaperEdit',
    homeworkPaperAdd: 'homeworkPaperAdd',
    homeworkExamList: 'homeworkExamList',
    homeworkExamDetail: 'homeworkExamDetail',
    homeworkExamEdit: 'homeworkExamEdit',
    homeworkExamAdd: 'homeworkExamAdd',
    myHomework: 'myHomework',
    myHomeworkIndex: 'myHomeworkIndex',
    myHomeworkDetail: 'myHomeworkDetail',
    homeworkScoringList: 'homeworkScoringList',
    homeworkScoringDetail: 'homeworkScoringDetail',
    questionTagManage: 'questionTagManage',
    questionTagList: 'questionTagList'
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    github: 'Github',
    screenfull: 'screenfull',
    theme: 'theme'
  },
  login: {
    title: 'Login',
    logIn: 'Login in',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  documentation: {
    documentation: 'Documentation',
    github: 'Github Repository'
  },
  permission: {
    roles: 'Your roles',
    switchRoles: 'Switch roles'
  },
  guide: {
    description: 'The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ',
    button: 'Show Guide'
  },
  components: {
    documentation: 'Documentation',
    tinymceTips: 'Rich text editor is a core part of management system, but at the same time is a place with lots of problems. In the process of selecting rich texts, I also walked a lot of detours. The common rich text editors in the market are basically used, and the finally chose Tinymce. See documentation for more detailed rich text editor comparisons and introductions.',
    dropzoneTips: 'Because my business has special needs, and has to upload images to qiniu, so instead of a third party, I chose encapsulate it by myself. It is very simple, you can see the detail code in @/components/Dropzone.',
    stickyTips: 'when the page is scrolled to the preset position will be sticky on the top.',
    backToTopTips1: 'When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner',
    backToTopTips2: 'You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally',
    imageUploadTips: 'Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.'
  },
  table: {
    dynamicTips1: 'Fixed header, sorted by header order',
    dynamicTips2: 'Not fixed header, sorted by click order',
    dragTips1: 'The default order',
    dragTips2: 'The after dragging order',
    title: 'Title',
    importance: 'Imp',
    type: 'Type',
    remark: 'Remark',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    reviewer: 'reviewer',
    id: 'ID',
    date: 'Date',
    author: 'Author',
    readings: 'Readings',
    status: 'Status',
    actions: 'Actions',
    edit: 'Edit',
    publish: 'Publish',
    draft: 'Draft',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    educated: 'Educated'
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export selected items',
    placeholder: 'Please enter the file name(default excel-list)'
  },
  zip: {
    export: 'Export',
    placeholder: 'Please enter the file name(default file)'
  },
  theme: {
    change: 'Theme change',
    documentation: 'Theme documentation',
    tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.'
  },
  tagsView: {
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js